/**
 * The sign-in screen.
 *
 * The note about what a panel password is worth is on the screen rather than in
 * a runbook, because this is where somebody is thinking about their password.
 */
import React, { useState } from "react";

import { ApiError, api } from "../api.js";

export default function SignIn({ onSignedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post("auth/sign-in", { username, password });
      onSignedIn();
    } catch (problem) {
      setError(problem instanceof ApiError ? problem.message : "Could not sign in.");
      setPassword("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="signin">
      <form className="card" onSubmit={submit}>
        <header>
          <h1>All Brains Clinic</h1>
          <p className="help">The website's admin panel.</p>
        </header>
        <div className="body">
          <div className="field">
            <label htmlFor="u">Username</label>
            <input
              id="u"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="p">Password</label>
            <input
              id="p"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="msg error">{error}</div>}

          <button className="primary" style={{ width: "100%", justifyContent: "center", marginTop: "0.4rem" }} disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <p className="hint" style={{ marginTop: "1rem" }}>
            Accounts are made by an Admin — there is no sign-up and no password reset by email. If
            you are locked out, ask the tech team.
          </p>
          <p className="hint">
            Whoever holds one of these passwords can change the public website. Treat it the way the
            Webflow password was treated.
          </p>
        </div>
      </form>
    </div>
  );
}
